<template>
  <div id="user-search" class="bg-white p-4 selection">
    <div class="row">
      <div class="col-md-12 mb-2">
        <a class="return" @click="returnToPreviousPage">
          <i class="fas fa-chevron-left"></i>
          {{ $t("events.newEvent.back") }}
        </a>
      </div>
  </div>
      
  <div class="row">
      <div class="col-md-4">
             <h3 class="black">{{ $t("events.guest.title") }} 2/2</h3>
      </div>
        <div class="col-md-4">
              <div class="container-input">
                        <input type="file" name="file-1" id="file-1" class="inputfile inputfile-1" @change="loadCSVUSER($event)" accept=".csv" data-multiple-caption="{count} archivos seleccionados" multiple />
                        <label for="file-1">
                        <i style='font-size:24px' class='fas'>&#xf6dd;</i>
                        <span class="iborrainputfile" id="filecsv1"> {{ $t("users.search.selectFile") }}</span>
                        </label>
                        <i style='font-size:26px' class='fas btn-outline-secondary' @click="showInf('USERS')">&#xf05a;</i>
                  </div>
      </div>

        <div class="col-md-2">
          <button class="select-btn" @click="openModal" v-if="emails.length === 0">
            {{ $t("events.guest.externalGuestBtn") }}
          </button>
          <button class="select-btn" @click="openModal" v-else>
            {{ $t("events.guest.externalGuestBtnAndSee") }}
          </button>
          </div>
           <div class="col-md-2">
          <button class="send-btn" @click="openAlertModal" :disabled="disableSave">
            {{ $t("events.guest.sendInvitationBtn") }}
          </button>
       
      </div>

  </div>
      
       <div class="row">
  
      <div class="col-md-6">
        
        <h5 class="black">
          {{ $t("events.guest.capacity") }} {{ quantity ? quantity : 0 }} {{$t("events.guest.guests") }}
          <!-- <i class="far fa-edit pointer" @click="openEditModal"></i> -->
           <i style='font-size:20px' class='far btn btn-outline-secondary' @click="openEditModal">&#xf044;</i>
        </h5>
      </div>
            <div class="col-md-3">
                  <h5 class="black">
                    {{ $t("events.guest.placesAvailables") }} {{ originalAvailablePlaces ? originalAvailablePlaces : 0 }}
                  </h5>
            </div>
                  <div class="col-md-3">
                      <h5 class="black">
                        {{ $t("events.guest.invitation") }} {{ event.sendInvitationsTotal ? event.sendInvitationsTotal : 0 }}
                      </h5>
                </div>
      
       </div>
    <div class="row">
      <div class="col-md-12">
        <div class="filters-selected">
          <h6 class="black bolded">
            {{ $t("events.guest.ticketsSend") }} ({{
              totalSelectedAndCompanions
            }})
          </h6>
          <div class="filters-pills">
            <!-- @click="openModal" -->
            <button
              type="button"
              class="btn btn-filter"
              v-if="this.emails.length > 0">
              {{ $t("events.newEvent.externalUsersPill") }}
              {{ externalUsersPlusFunction }}
            <i style="font-size:15px" class="fa btn btn-outline-secondary" @click="openModal">&#xf00e;</i>
            <i style="font-size:15px" class="fa btn btn btn-outline-danger" @click="cancelAndCleanExternalUsers">&#xf057;</i>
            </button>
            <button
              type="button"
             class="btn btn-filter"
              v-for="(item, index) in filters"
              :key="index"
            >
              {{
                $t(`users.search.table.headings.${item.label.split("-")[0]}`) +
                "-"
              }}: {{ item.value }} {{ $t("events.guest.guests") }} {{ item.data.length }}
          <i style="font-size:15px" class="fa btn btn-outline-secondary" @click="showData(index)">&#xf00e;</i>
            <i style="font-size:15px" class="fa btn btn btn-outline-danger" @click="removeFilter(index)">&#xf057;</i>
            </button>
          </div>
        </div>
      </div>
    </div>
    <v-server-table
      :columns="table_options.columns"
      :options="table_options.options"
      ref="userTable"
    >
      <!-- Select All -->
      <template #filter__carritochk>
        <label for="toggleAll">{{ $t("users.search.table.toggleAll") }}</label>
        <br />
        <input
          type="checkbox"
          name="toggleAll"
          id="toggleAll"
          v-model="allChecked"
          v-on:click="selectAll"
        />
      </template>
       <template #filter__select>
         <button class="select-btnAdd" @click="addUsers">{{ $t("users.search.addUsers") }}</button>
      </template>
      <!-- Checks -->
      <template v-slot:select="props">
        <input
          disabled
          type="checkbox"
          :name="`select${props.row.id}`"
          :id="`select${props.row.id}`"
          :value="props.row.id"
          v-model="selected"
        />
      </template> 
           <template v-slot:carritochk="props">
        <input
          type="checkbox"
          :name="`select${props.row.id}`"
          :id="`select${props.row.id}`"
          :value="props.row.controlNumber"
          v-model="carrito"
          v-on:click="chkcarrito(props.row.controlNumber,$event,props.row.id)"
        />
      </template> 
      <!-- Created -->
      <template #createdAt="props">
        {{ props.row.createdAt | formatDate(appLang) }}
      </template>
      <!-- Updated -->
      <template #updatedAt="props">
        {{ props.row.updatedAt | formatDate(appLang) }}
      </template>
    </v-server-table>
   <b-modal size="sm" centered ref="my-error" hide-footer  scrollable :title="$t('users.search.noValidData')" tabindex="-1" >
    <ul id="example-1">
          <li v-for="(err,index) in error" :key="index">
            {{ err }}
          </li>
    </ul>
    </b-modal>
        <b-modal style="z-index:20" centered ref="my-info" hide-footer  scrollable :title="$t('users.search.infoCsv')" tabindex="-1" >
       <div v-if="appLang =='es'">
        <div v-if="show =='USERS'">
          <center>
             <p>
              Archivo en formato .csv 
              <br/>
              Nombre de columna "no_control"
               <br/>
              Formato de celda "Texto"
               <br/>
              Cada registro debe contar con 6 caracteres
            </p>
            </center>
          </div>
            <div v-if="show =='EMAIL'">
            <center>
             <p>
              Archivo en formato .csv
              <br/>
                 Nombre de columnas  "Email","Tickets"
                  <br/>
                  "Email": descripcion@dominio.com (Ejemplo)
                    <br/>
                    "Tickets": Número de ticket que se enviaran al invitado.
            </p>
            </center>
          </div>
            </div>
                <div v-if="appLang =='en'">
                <div v-if="show =='USERS'">
                <center>
                File in .csv format
                <br/>
                Column name "no_control"
                  <br/>
                  Format cell "Text"
                    <br/>
                    Each record must have 6 characters
                    </center>
                    </div>
                      <div v-if="show =='EMAIL'">
                      <center>
                        File in .csv format
                        <br/>
                        Columns name "Email","Tickets"
                          <br/>
                          "Email": descripción@dominio.com(Example)
                            <br/>
                            "Tickets": Ticket number that will be sent to the guest
                            </center>
                    </div>
                </div>
    </b-modal>
         <b-modal :modal-class="classmodal" size="xl" centered ref="my-modal" hide-footer  scrollable :title="$t('users.search.listDetail')" tabindex="-1" >
      
         <!-- <b-button size="lg" class="pull-right" style="height:80px; width:60px;font-size:30px; background-color:#ffffcc; color:#FFCD00" variant="outline-gray" @click="hideModal()"><h1>X</h1></b-button>
          <br/> -->
        <div class="row">
                          <div class="col-md-12">
                            <v-client-table v-if="tableData" :data="tableData" :columns="table_optionsCarga.columns" :options="table_optionsCarga.options"/>
                          </div>   
        </div>
  

    </b-modal>
    <Modal
      v-if="modalActive"
      v-on:closeModal="closeModal"
      :class="editModal ? 'modal-alert' : ''"
    >

      <template #header>
        <h5 v-if="!alertModal && !editModal" class="modal-title bolded">
          {{ $t("events.guest.modal.title") }}
        </h5>
        <h5 v-if="alertModal">{{ $t("events.guest.modal.atention") }}</h5>
        <h6 v-if="editModal" class="modal-title bolded">
          {{ $t("events.guest.addMoreCapacity") }}
        </h6>
      </template>
      <template>
        <div v-if="!alertModal && !editModal" class="body-modal">
          <div class="body-header">
            <h6 class="mr-4">
              {{ $t("events.guest.capacity") }}
              {{ quantity ? quantity : 0 }}
              {{ $t("events.guest.guests") }}
               <i style='font-size:16px' class='far btn btn-outline-secondary' @click="openEditModal">&#xf044;</i>
            </h6>
            <h6>
              {{ $t("events.guest.placesAvailables") }}
              {{ originalAvailablePlaces ? originalAvailablePlaces : 0 }}
            </h6>
          </div>

          <div
            class="form-inputs-line mt-4"
            :class="emails.length > 0 ? 'scrollable' : ''"
          >
            <div v-for="(item, index) in emails" :key="index">
              <p
                v-if="emails[index].availableTickets > maxNumberInvitation"
                class="alert-text"
              >
                {{ $t("events.guest.modal.maxQuantityTickets") }}
              </p>
              <div class="inputs-clone mb-3">
                <div class="form-input-1">
                  <label class="bolded">
                    {{ index ? +index + 1 : "1" }}.
                    {{ $t("events.guest.modal.destinataryEmail") }}
                  </label>
                  <input
                    type="text"
                    :class="emailReg.test(item.email) ? '' : 'warning-input'"
                    :placeholder="
                      $t('events.guest.modal.destinataryEmailPlaceholder')
                    "
                    v-model="emails[index].email"
                  />
                  <p v-if="!emailReg.test(item.email)">
                    {{ $t("events.guest.modal.invalidEmail") }}
                  </p>
                  <i @click="removeEmail(index)" class="fas fa-times"></i>
                </div>
                <div class="form-input-2">
                  <label class="bolded">
                    {{ $t("events.guest.modal.numberTickets") }}
                  </label>
                  <input
                    type="number"
                    :placeholder="0"
                    class="text-center"
                    v-model.number="emails[index].availableTickets"
                    :max="maxNumberInvitation"
                    :min="1"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="add-btn mt-4" @click="addEmail">
            <div class="add">+</div>
            <p class="bolded mt-3">
              {{ $t("events.guest.modal.addDestinatary") }}
            </p>
          </div>
        </div>


        <div class="body-modal">
          <p v-if="alertModal">
            {{ $t("events.guest.modal.modal-body") }} {{ totalInvitations }}
            {{ $t("events.guest.modal.modal-body2") }}
            {{ event.name ? event.name : "" }}.
          </p>
          <p v-if="alertModal">{{ $t("events.guest.modal.sureAlert") }}</p>
          <input
            :class="
              quantity % (+event.numberCompanionsAllowed + 1) !== 0 ||
              quantity < originalAvailablePlaces
                ? 'warning-input'
                : ''
            "
            v-if="editModal"
            type="number"
            class="quantity"
            v-model.number="quantity"
            :min="event.availablePlaces"
          />
          <p
            class="alert-text"
            v-if="
              quantity % (+event.numberCompanionsAllowed + 1) !== 0 && editModal
            "
          >
            {{ $t("events.newEvent.multiplesAlert") }}
            {{ +event.numberCompanionsAllowed + 1 }}
          </p>
          <p class="alert-text" v-if="quantity < originalAvailablePlaces">
            {{ $t("events.newEvent.minorValue") }} {{ originalAvailablePlaces }}
          </p>
        </div>


      </template>
      <template #footer>
        <div class="controls">

         <div v-if="!alertModal && !editModal"  class="container-input">
                        <input type="file" name="file-2" id="file-2" class="inputfile inputfile-2" @change="loadCSV($event)" accept=".csv" data-multiple-caption="{count} archivos seleccionados" multiple />
                        <label for="file-2">
                        <i style='font-size:24px' class='fas'>&#xf6dd;</i>
                        <span class="iborrainputfile" id="filecsv"> {{ $t("users.search.selectFile") }}</span>
                        </label>
                        <i style='font-size:24px' class='fas btn-outline-secondary' @click="showInf('EMAIL')">&#xf05a;</i>
                  </div>
          <span class="control cancel-btn" @click="cancelAndCleanExternalUsers">
            {{ $t("surveys.modal.cancel") }}
          </span>
          <button
            type="control button"
            @click="closeModal"
            class="btn-save"
            :class="emails.length === 0 ? 'btn-disable' : ''"
            :disabled="emails.length === 0"
            v-if="!alertModal && !editModal"
          >
            {{ $t("surveys.modal.save") }}
          </button>
          <button
            type="control button"
            @click="sendInvitations"
            class="btn-save"
            v-if="alertModal"
          >
            {{ $t("events.guest.sendInvitationBtn") }}
          </button>
          <span
            v-if="editModal"
            type="control button"
            class="btn-save"
            :class="
              quantity % (+event.numberCompanionsAllowed + 1) !== 0 ||
              quantity < originalAvailablePlaces
                ? 'disable-upload'
                : ''
            "
            @click="changeAvailablePlaces"
            >{{ $t("events.guest.modify") }}</span
          >
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
import moment from "moment";
import USER_API_SERVICE from "@/lib/api/Users.js";
import EVENT_API_SERVICE from "@/lib/api/Events.js";

const Modal = () => import("@/components/Modal");

import lodash from "lodash";
const api = new USER_API_SERVICE();
const apiEvent = new EVENT_API_SERVICE();
export default {
  components: {
    Modal,
  },
  props: {
    return_to_path: {
      required: false,
    },
    path_id: {
      required: false,
    },
  },
  data: function () {
    return {
      classmodal: ['classmodal'],
      carrito:[],
      carritoSelected:[],
      cont:0,
      error:[],
      show:"",
      sortOrders:{},
      users: null,
      selected: [],
      allChecked: false,
      usersParams: {},
      dinamycObj: {},
      filters: [],
      arrayDinamycObj: [],
      event: {},
      modalActive: false,
      emails: [],
      alertModal: false,
      totalInvitations: 0,
      editModal: false,
      quantity: 0,
      originalAvailablePlaces: 0,
      maxNumberInvitation: 10,
      disableSave: false,
      alertForQuantityOfTickets: false,
      controlNumbersUsers: [],
      originalControlNumbers: [],
      emailReg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
      columns: [
          "name",
          "lastname",
          "motherslastname",
          "controlnumber",
          "companyemail",
          "directbosscontrolnumber",
          "uo",
          "uoDescription",
          "iduo",
          "funcion",
          "birthdate",
          "gender",
          "admissiondate",
          "workingshift",
          "dailyworkingshift",
          "maritalstatus",
          "numberofchildren",
          "personalcellphonenumber",
          "status",
          "type",
          "typedescription"],
        tableData: null
    };
  },
  filters: {
    birthdateFormat: function (value) {
      if (value) return moment(value).format("l");
    },
  },

  computed: {
    appLang: function () {
      return this.$store.getters["settings/currentLang"];
    },
    userTable: function () {
      return this.$refs.userTable;
    },
    table_columns: function () {
      return [
        "carritochk",
        "select",
        "name",
          "lastName",
          "mothersLastName",
          "controlNumber",
          "companyEmail",
          "directBossControlNumber",
          "uo",
          "uoDescription",
          "idUo",
          "funcion",
          "birthdate",
          "gender",
          "admissionDate",
          "workingShift",
          "dailyWorkingShift",
          "maritalStatus",
          "numberOfChildren",
          "personalCellphoneNumber",
          "status",
          "type",
          "typeDescription"
      ];
    },
    table_headings: function () {
      if (this.table_columns) {
        const headings = {};
        this.table_columns.forEach((column) => {
          headings[column] = this.$t(`users.search.table.headings.${column}`);
        });
        return headings;
      }
      return null;
    },
    table_filters: function () {
      return this.table_columns.filter((column) => column !== "select" && column !== "carritochk");
    },
    table_options: function () {
      return {
        columns: this.table_columns,
        options: {
          columnsDropdown: true,
          filterByColumn: true,
          headings: this.table_headings,
          filterable: this.table_filters,
          sortable: [],
          perPage: 25,
          resizableColumns: false,
          perPageValues: [10, 25, 50, 100],
          columnsClasses: {
            select: "select-column",
            id: "id-column",
          },
          texts: {
            filterBy: "{column}",
            columns: this.$t("users.search.table.column_toggler"),
          },
          requestAdapter: function (data) {
            const queries = {};
            queries.page = data.page - 1;
            queries.limit = data.limit;
            queries.query = data.query;
            queries.cmsUserFilter = 'collaborator';
            return queries;
          },
          requestFunction: async function (data) {
            this.$store.commit("global/SET_LOADING", true);
            try {
              let internalUsers = [];
              const resp = await api.getUsers(data);
             
              this.$emit("tipo");

              for (let index = 0; index < resp.data.length; index++) {
                let colaborador =
                  resp.data[index].name +
                  " " +
                  resp.data[index].lastName +
                  " " +
                  resp.data[index].mothersLastName;
                resp.data[index].colaborador = colaborador;
              }
              let contador = 0;
              let arrayControlNumbers = [];
              if (this.$route.params.event.orginalInternalUsers && this.$route.params.event.orginalInternalUsers.length > 0) {
                internalUsers = this.$route.params.event.orginalInternalUsers;

                resp.data = resp.data.filter((val) => {
                  //internalUsers.includes(val.id)

                  if (!internalUsers.includes(val.id)) {
                    contador++;
                    return val;
                  } else {
                    arrayControlNumbers.push(val.controlNumber);
                  }
                });
              }
              this.$route.params.originalControlNumbers = arrayControlNumbers;
              this.$store.commit("global/SET_LOADING", false);
              resp.total = resp.total - contador;
              return resp;
            } catch (error) {
              this.$store.commit("global/SET_LOADING", false);
              throw error;
            }
          },
          responseAdapter: function (response) {
            return {
              data: response.data,
              count: response.total,
            };
          },
        },
      };
    },

        table_headingsCarga: function () {
      if (this.columns) {
        const headings = {};
        this.columns.forEach((column) => {
          headings[column] = this.$t(`users.search.tableCarga.headings.${column}`);
        });
        return headings;
      }
      return null;
    },
    table_filtersCarga: function () {
      return this.columns.filter((column) => column !== "select");
    },

 table_optionsCarga: function () {
      return {
        columns: this.columns,
        options: {
          columnsDropdown: true,
          filterByColumn: true,
          headings: this.table_headingsCarga,
          filterable: this.table_filtersCarga,
          sortable: [],
          resizableColumns: false,// columnas fijas
          perPage: 25,
          perPageValues: [10, 25, 50, 100],
          columnsClasses: {
            select: "select-column",
            id: "id-column",
          },
          texts: {
            filterBy: "{column}",
            columns: this.$t("users.search.table.column_toggler"),
            limit: this.$t("users.search.table.limit")
          },
        },
      };
    },

    recipients: function () {
      return this.$store.getters["users/recipients"];
    },
    externalUsersPlusFunction() {
      let tickets = 0;
      for (let index = 0; index < this.emails.length; index++) {
        tickets += this.emails[index].availableTickets;
      }
      return tickets;
    },
    totalSelectedAndCompanions(){
        if (this.$route.params.event.numberCompanionsAllowed > 0 && this.selected.length) {         
        return (
          this.selected.length *
            (this.$route.params.event.numberCompanionsAllowed +
         1)
        );
      }
      return this.selected.length
    },
    totalOfExternalAndSelected() {
    
      return this.totalSelectedAndCompanions + this.externalUsersPlusFunction;
    },
  },

  beforeMount: async function () {
    if (this.$route.params.event) {
      this.event = this.$route.params.event;
      this.quantity = this.$route.params.event.availablePlaces;
      this.originalAvailablePlaces = this.$route.params.event.availablePlaces;
    }
  },
  mounted() {
    this.$on("vue-tables.userTable.filter", function (data) {});
    if (this.$route.params.eventId) {
      this.$route.params.event.internalUsers = [];
    }
  },
  methods: {
       showModal() {
      this.$refs['my-modal'].show();
    },
         showData: async function (index) {
            try {
               if(index =="all"){
                if(this.selected.length==0)
                {
                  this.$store.commit("global/SET_ALERT", {
                  msg: this.$t("users.search.noRegister"),
                  show: true,
                  type: "error"
                });

                }
                else{
                this.showModal();
                this.$store.commit("global/SET_LOADING", true);
                const resp = await api.getFromArray({"controlNumbers":this.controlNumbersUsers});
                this.tableData = resp.data;
                this.$store.commit("global/SET_LOADING", false);
                }
                
               }
              else{
                this.showModal();
                this.$store.commit("global/SET_LOADING", true);
                const resp = await api.getFromArray({"controlNumbers":this.filters[index].controlNum});
                this.tableData = resp.data;
                this.$store.commit("global/SET_LOADING", false);
                }
              

            } catch (error) {
              this.$store.commit("global/SET_LOADING", false);
              throw error;
              
            }
    
    },

     showInf: function(e){
      this.$refs['my-info'].show();
      this.show = e;
    },
   async chkcarrito(Number,cb,id)
    {
      
    if(cb.target.checked)
    {
        this.carrito.push(Number);
        this.carritoSelected.push(id);
    }
    else{
       this.carrito = this.carrito.filter((e)=> e !== Number );
       this.carritoSelected = this.carritoSelected.filter((e)=> e !== id);
       
    }},
        loadCSV(e){
        var vm = this
        if(window.FileReader){
          var reader = new FileReader();
          reader.readAsText(e.target.files[0]);
          document.getElementById('filecsv').textContent = e.target.files[0].name;
          reader.onload = function(event){
            var csv = event.target.result;
            vm.parse_csv = vm.csvJSON(csv)
          };
          reader.onerror = function(evt){
            if(evt.target.error.name=='NotReadableError'){
              console.log("Canno´t read File !");
            }
          };
        }
        else{
          console.log('FileReader are not supported in this browser');
        }
    },     
    loadCSVUSER(e){
        var vm = this
        if(window.FileReader){
          var reader = new FileReader();
          reader.readAsText(e.target.files[0]);
          document.getElementById('filecsv1').textContent = e.target.files[0].name;
          reader.onload = function(event){
            var csv = event.target.result;
            vm.parse_csv = vm.csvJSONUSER(csv)

          };
          reader.onerror = function(evt){
            if(evt.target.error.name=='NotReadableError'){
              console.log("Canno´t read File !");
            }
          };
        }
        else{
          console.log('FileReader are not supported in this browser');
        }
    },
     csvJSONUSER: async function(csv){

        this.$store.commit("global/SET_LOADING", true);
    
    try {
       var vm = this
       var lines = csv.split("\r\n")
       var result =[]
       var result2 =[]
       var headers = lines[0].split(",")
       vm.parse_header = lines[0].split(",")

       lines[0].split(",").forEach(function(key){
         vm.sortOrders[key] = 1
       })
       lines.map(function(line,indexline){
         if(indexline <1) return 

         var obj = {}
         var currentline = line.split(",")
           headers.map(function(header,indexHeader){
           obj[header] = currentline[indexHeader]
           var dato =  currentline[indexHeader]
            if(dato.length<6){
             
              result.push(dato);
            }
            else if(dato.length>7){
              result.push(dato)}
            else if(isNaN(dato)){
              result.push(dato);
            }
            else{
            result2.push(currentline[indexHeader]);
            }
         })
       })
   
       if(result2.length>0){
        const resp = await api.getFromArray({"controlNumbers":result2});
        this.$store.commit("global/SET_LOADING", false);
        this.carritoSelected = resp.data.map((key) => key.id);
        this.carrito = resp.data.map((key) => key.controlnumber);
        this.selected = this.selected.concat(this.carritoSelected);
        this.controlNumbersUsers = this.controlNumbersUsers.concat(this.carrito);
        this.selected = this.cleanRepeatedControlsNumbers(this.selected);
        this.controlNumbersUsers = this.cleanRepeatedControlsNumbers(this.controlNumbersUsers);

            this.$store.commit("global/SET_ALERT", {
                 msg: this.$t("users.search.userAdd") + this.carrito.length ,
                 show: true,
                 type: "success"
               });
          this.filters.push({
          data: this.carritoSelected,
          label: "Carga",
          value: "CSV",
          total: this.carrito.length,
          controlNum: this.carrito
          });

      this.carrito=[];
      this.carritoSelected =[];
      }
      this.$store.commit("global/SET_LOADING", false);
         this.error = result; 
            if(this.error.length>0){
              this.$refs['my-error'].show();
            }
         
      return result;
      } 
      catch (error) 
      {
           this.$store.commit("global/SET_LOADING", false);
           this.$store.commit("global/SET_ALERT", {
                 msg: error ,
                 show: true,
                 type: "error"
               });
        }
     },

    csvJSON(csv){
    var allTextLines = csv.split(/\r\n|\n/);
    var headers = allTextLines[0].split(',');
    for (var i=1; i<allTextLines.length; i++) {
        var data = allTextLines[i].split(',');
        if (data.length == headers.length) {

            var tarr = [];
            for (var j=0; j<headers.length; j++) {
                tarr.push(data[j]);
            }
                     this.emails.push({
                                          email: tarr[0],
                                          availableTickets: parseInt(tarr[1]),
                                        });
        }
    }
                this.$store.commit("global/SET_ALERT", {
                msg: this.$t("users.search.Succes")+" "+ this.emails.length,
                show: true,
                type: "success"
               });
        return result; 

     },
      sortBy: function(key){
       var vm = this
       vm.sortKey = key
       vm.sortOrders[key] = vm.sortOrders[key] * -1

     },
    fillOne(id, numberControl, event) {
      if (event.target.checked) {
        this.selected.push(id);
        this.controlNumbersUsers.push(numberControl);
      } else {
        const index = this.selected.indexOf(id);
        if (index > -1) {
          this.selected.splice(index, 1);
        }
        const index2 = this.controlNumbersUsers.indexOf(numberControl);
        if (index > -1) {
          this.controlNumbersUsers.splice(index, 1);
        }
      }
    },
    cleanRepeatedControlsNumbers(selected = []) {
      return this.lodash.uniqBy(selected, function (e) {
        return e;
      });
    },
    openModal: function () {
      this.modalActive = true;
      this.alertModal = false;
    },
    openAlertModal: function () {
      this.alertModal = true;
      this.modalActive = true;
      this.totalInvitations = this.totalOfExternalAndSelected;
    },
    closeModal: function () {
      this.modalActive = false;
      this.alertModal = false;
      this.editModal = false;
      if (this.emails.length > 0) {
        for (let index = 0; index < this.emails.length; index++) {
          if (this.emails[index].availableTickets > 10) {
            this.disableSave = true;
          } else {
            this.disableSave = false;
          }
        }
      }
    },
    openEditModal() {
      this.editModal = true;
      this.modalActive = true;
      this.alertModal = false;
    },
    removeCurrenUsers() {
      this.selected = [];
      this.filters = [];
      this.controlNumbersUsers = [];
      this.allChecked = false;
    },
    addEmail() {
      //Agrega mas correos de destinatario dinamicamente
      this.emails.push({
        email: "",
        availableTickets: 0,
      });
    },
    removeEmail(index) {
      this.emails.splice(index, 1);
    },
    async addUsers() {
     if(this.carrito.length==0){
        this.$store.commit("global/SET_ALERT", {
                 msg: this.$t("users.search.noUser"),
                 show: true,
                type: "error"
               });
} 
else{
      let filters = this.lodash.cloneDeep(this.$refs.userTable._data.query);
      let keyAux = "";
      let values = "";
        for (const key in filters)
      {
      if
        (filters[key] === "")
                                {

                                }
                                                        else
                                                              {
                                                                keyAux += key + "-";
                                                                values += filters[key] + "-";
                                                              }
      }
   
      let controlNumbers = this.selected;
      if (this.dinamycObj.hasOwnProperty(keyAux)) {
        this.dinamycObj[keyAux] = this.dinamycObj[keyAux].concat(
          controlNumbers
        );
      } else {
        this.dinamycObj[keyAux] = controlNumbers;
      }
           if (keyAux === "") {
          this.filters.push({
          data: this.carritoSelected,
          label: "all"+ "-" + this.cont++,
          value: "Lista-"+ this.cont++,
          total: this.carrito.length,
          controlNum: this.carrito
        });
      } else {
        this.filters.push({
          data: this.carritoSelected,
          label: keyAux,
          value: values,
          total: this.carrito.length,
          controlNum: this.carrito
        });
      }
        this.selected = this.selected.concat(this.carritoSelected);
        this.controlNumbersUsers = this.controlNumbersUsers.concat(this.carrito);
        this.selected = this.cleanRepeatedControlsNumbers(this.selected);
        this.controlNumbersUsers = this.cleanRepeatedControlsNumbers(this.controlNumbersUsers);
            this.$store.commit("global/SET_ALERT", {
                 msg: this.$t("users.search.userAdd") + this.carrito.length ,
                 show: true,
                type: "success"
               });
      this.carrito=[];
      this.carritoSelected =[];
      this.allChecked = false;
      this.$store.commit("global/SET_LOADING", false);
    }
    },
     async addUsers1() {
      let filters = this.lodash.cloneDeep(this.$refs.userTable._data.query);
      let keyAux = "";
      let values = "";
      for (const key in valores) {
        if (filters[key] === "") {
          delete filters[key];
        } else {
          keyAux += key + "-";
          values += filters[key];
        }
      }
      let data = {
        page: this.$refs.userTable._data.page - 1,
        limit: this.$refs.userTable._data.limit,
        query: filters,
        all: true,
      };
      let appendArray = [];
      let appendControlNumbers = [];
      const resp = await api.getUsers(data);
      // Get only control numbers in specific filter
      let respFilter = resp.data.filter(
        (key) => !this.$route.params.event.orginalInternalUsers.includes(key.id)
      );
      for (const key in this.dinamycObj) {
        respFilter = respFilter.filter(
          (resp) => !this.dinamycObj[key].includes(resp.id)
          
        );
      }
      let controlNumbers = respFilter.map((key) => key.id);
      let fillControl = respFilter.map((key) => key.controlNumber);
      if (this.dinamycObj.hasOwnProperty(keyAux)) {
        this.dinamycObj[keyAux] = this.dinamycObj[keyAux].concat(
          controlNumbers
        );
      } else {
        this.dinamycObj[keyAux] = controlNumbers;
      }
   
      // Global unique array users
      if (controlNumbers.length) {
        if (keyAux === "") {
          this.filters.push({
            data: controlNumbers,
            label: "all",
            value: "",
          });
        } else {
          if (this.filters.length > 0) {
            for (let index = 0; index < this.filters.length; index++) {
              if (
                this.filters[index].label !== keyAux ||
                this.filters[index].value !== values
              ) {
                this.filters.push({
                  data: controlNumbers,
                  label: keyAux,
                  value: values,
                  controlNum: fillControl,
                });
              }
            }
          } else {
            this.filters.push({
              data: controlNumbers,
              label: keyAux,
              value: values,
              controlNum: fillControl,
            });
          }
        }

        this.selected = this.selected.concat(this.dinamycObj[keyAux]);
        this.controlNumbersUsers = this.controlNumbersUsers.concat(fillControl);
        this.selected = this.cleanRepeatedControlsNumbers(this.selected);
        this.controlNumbersUsers = this.cleanRepeatedControlsNumbers(
        this.controlNumbersUsers
        );
      }
      
    },

    selectAll: async function () {
      try {
        if (!this.allChecked) {
          let clone = this.lodash.cloneDeep(this.$refs.userTable._data.query);
          //Poner filtros
          for (const key in clone) {
            if (clone[key] === "") {
              delete clone[key];
            }
          }

          let data = {
            page: this.$refs.userTable._data.page - 1,
            limit: this.$refs.userTable._data.limit,
            query: clone,
            all: true,
          };
          let appendArray = [];
          let appendControlNumbers = [];
          const resp = await api.getUsers(data);
          appendArray = resp.data.map((key) => key.id);
          appendControlNumbers = resp.data.map((key) => key.controlNumber);
          this.carritoSelected = this.carritoSelected.concat(appendArray);
          this.carritoSelected = this.cleanRepeatedControlsNumbers(this.carritoSelected);
          this.carrito = this.carrito.concat(
            appendControlNumbers
          );
          this.carrito = this.cleanRepeatedControlsNumbers(
            this.carrito
          );
        } else {
          this.carrito = [];
          this.carritoSelected = [];
        }
      } catch (error) {
        throw error;
      }
    },
    removeFilter: function (index) {
      let key = this.filters[index].label;

     

      if(key == "Carga"){
        document.getElementById("file-1").value = "";
        document.getElementById('filecsv1').textContent = "Selecciona Archivo";
      }
      delete this.dinamycObj[key];
      let arrayToRemove = this.filters[index].data;
      let controlToRemove = this.filters[index].controlNum;
      this.filters.splice(index, 1);
      this.selected = this.selected.filter((el) => !arrayToRemove.includes(el));
      this.controlNumbersUsers = this.controlNumbersUsers.filter(
        (el) => !controlToRemove.includes(el)
      );
    },
    async sendInvitations() {
      this.$store.commit("global/SET_LOADING", true);
      try {
        if (this.selected.length > 0 || this.emails.length > 0) {
          this.event.internalUsers = this.selected;
          this.event.published = true;
          //this.emails son los usuarios externos
          if (this.$route.params.eventId) {
            const event = await apiEvent.editEvent(
              this.event,
              this.$route.params.eventId
            );
            if (this.emails.length > 0) {
              //construir evento
              this.event.externalUsers = this.emails;
              this.event.id = this.$route.params.eventId;
              let params = {
                id: this.$route.params.eventId,
                name: this.event.name,
                description: this.event.description,
                validFromEvent: this.event.validFromEvent,
                validToEvent: this.event.validToEvent,
                location: this.event.location,
                availablePlaces: this.event.availablePlaces,
                companionsAllowed: this.event.companionsAllowed,
                numberCompanionsAllowed: this.event.numberCompanionsAllowed,
                image: this.event.image,
                confirmationRequired: this.event.confirmationRequired,
                sendSurvey: this.event.sendSurvey,
                validFromApp: this.event.validFromApp,
                validToApp: this.event.validToApp,
                published: this.event.published,
                sharedAllowed: this.event.sharedAllowed,
                internalUsers: this.event.internalUsers,
                externalUsers: this.emails,
                surveyId: this.$route.params.event.surveyId,
              };
              const sendExternal = await apiEvent.sendExternalUsersInvitation(
                params
              );
            }
            let arrayJoin = this.controlNumbersUsers.concat(
              this.$route.params.event.originalControlNumbers
            );

            const assign = apiEvent.assignUsersToSurvey({
              id: this.$route.params.event.surveyId,
              assignedUsers: arrayJoin,
            });
          } else {
            this.event.surveyId = this.$route.params.event.surveyId;

            const event = await apiEvent.createEvent(this.event);
            const assign = apiEvent.assignUsersToSurvey({
              id: this.$route.params.event.surveyId,
              assignedUsers: this.controlNumbersUsers,
            });

            if (this.emails.length > 0) {
              this.event.id = event.created.id;
              this.event.externalUsers = this.emails;
              const sendExternal = await apiEvent.sendExternalUsersInvitation(
                this.event
              );
            }
          }

          this.totalInvitations = 0;
          this.$router.push({
            name: "Event List",
          });
          //Ya crea el evento falta las validaciones y los external users
        }
      } catch (error) {
        console.log(error);
        this.$store.commit("global/SET_LOADING", false);
      } finally {
        this.$store.commit("global/SET_LOADING", false);
        this.closeModal();
      }
    },
    returnToPreviousPage() {
      if (this.$route.params.eventId) {
        this.$router.push({
          name: "Edit Event",
          id: this.$route.params.eventId,
          params: {
            isHappeningEvent: this.$route.params.isHappeningEvent,
            isEdit: true,
            id: this.$route.params.eventId,
          },
        });
      } else {
        this.$router.push({
          name: "New Event",
          params: {
            isHappeningEvent: this.$route.params.isHappeningEvent,
            event: this.$route.params.event,
            isNewParams: true,
          },
        });
      }
    },
    async changeAvailablePlaces() {
      this.$store.commit("global/SET_LOADING", true);
      try {
        if (this.$route.params.eventId) {
          const resp = await apiEvent.editEvent(
            { availablePlaces: this.quantity },
            this.$route.params.eventId
          );
          this.originalAvailablePlaces = this.quantity;
          this.originalAvailablePlaces =
            this.quantity - this.$route.params.event.busyPlaces;
        } else {
          this.originalAvailablePlaces = this.quantity;
        }
      } catch (error) {
        console.log(error);
        this.$store.commit("global/SET_LOADING", false);
      } finally {
        this.$store.commit("global/SET_LOADING", false);
        this.closeModal();
      }
    },
    cancelAndCleanExternalUsers() {
      this.emails = [];
      this.closeModal();
    },
  },
};
</script>

<style lang="scss">


/**********File Inputs**********/
.container-input {
   
    text-align: center;
    background: #fff; //#b6b0b0;
    top: 30px;
    border-top: 5px solid #fff; //#000000;
    padding: 5px 0;
    border-radius: 6px;
    width: 70%;
    height: 70%;
    margin: 0 auto;
    margin-bottom: 1em;
}

.inputfile {
    width: 0.1px;
    height: 0.1px;
    opacity: 0;
    overflow: hidden;
    position: absolute;
    z-index: -1;
   
}

.inputfile + label {
    max-width: 100%;
    font-size: 1.35rem;
    font-weight: 200;
    text-overflow: ellipsis;
    white-space: nowrap;
    cursor: pointer;
    display: inline-block;
    overflow: hidden;
    padding: 0.625rem 1.25rem;
}

.inputfile + label i {
    width: 1em;
    height: 1em;
    vertical-align: middle;
    fill: currentColor;
    margin-top: -0.25em;
    margin-right: 0.05em;
}

.iborrainputfile {
  font-size:14px; 
  // font-weight:normal;
  // font-family: 'Lato';
}

/* style 1 */

.inputfile-2 + label {
    color: #fff;
    background-color: #000000;
}

.inputfile-2:focus + label,
.inputfile-2.has-focus + label,
.inputfile-2 + label:hover {
    background-color: #ffffff;
     color: #000000;
      border: 1px solid #000000;
}
.inputfile-1 + label {
    color: #fff;
    background-color: #000000;
}

.inputfile-1:focus + label,
.inputfile-1.has-focus + label,
.inputfile-1 + label:hover {
    background-color: #ffffff;
     color: #000000;
      border: 1px solid #000000;
}
.select-btn {
  width: 100%;
  height: 65%;
  align-self: center;
  font-size: 14px;
  background-color: $black;
  color: $white;
  border: 1px solid $black;
  border-radius: 0;
  padding: 0.7rem 2rem;
  margin: 1rem 0;
}
.send-btn {
  width: 100%;
  height: 65%;
  font-size: 12px;
  align-self: center;
  background-color: $white;
  color: $black;
  border: 1px solid $black;
  border-radius: 0;
  padding: 0.7rem 2rem;
  margin: 1rem 0;
}
</style>

<style lang="scss">
.select-btnAdd {
  align-self: center;
  background-color: $black;
  color: $white;
  border: 1px solid $black;
  border-radius: 0;
  padding: 0.5rem 2rem;
  margin: 1rem 0;
}
  .VueTables thead  { 
            position: sticky;
            top: 0;
            z-index: 1;
            background-color: #fff;
        }
        .table-responsive { 
            height:600px;
            overflow:scroll;
        }
  #user-search {
  .pull-right {
    float: none;
  }
  .VueTables .dropdown {
    margin: 1rem 0;
  }
  .VueTables__columns-dropdown {
  float: left !important;
}
  .VueTables .dropdown > button {
    @extend %audi;
    color: $black;
    background-color: transparent;
    border: 1px solid $black;
    border-radius: 0;
    padding: 5px 10px;
  }
  .VueTables .dropdown .dropdown-menu {
    padding: 1rem;
    a {
      color: $black;
      display: flex;
      align-items: center;
      justify-content: flex-start;
    }
    a > input {
      margin-right: 0.5rem;
    }
    input[type="checkbox"][value="select"] {
      display: none;
    }
  }
  .VueTables__table.table {
    min-width: 100%;
    width: max-content;
  }
  .VueTables__table .select-column {
    position: sticky;
    left: 0;
    text-align: center;
    &:after {
      content: "";
      width: 100%;
      height: 100%;
      position: absolute;
      background-color: #f2f2f2;
      top: 0;
      left: 0;
      border-collapse: collapse;
    }
  }
  .VueTables__table .select-column > * {
    position: relative;
    z-index: 1;
  }
  .table-striped tbody tr:nth-of-type(odd) > .select-column {
    &:after {
      background-color: #e6e6e6;
    }
  }
  .VueTables__table .id-column {
    max-width: 100px;
  }
  [class$="filter-wrapper"] {
    min-width: 80px;
    max-width: fit-content;
  }
}

.VueTables__table .actions-column {
    position: sticky;
    right: 0;
    text-align: center;
    &:after {
      content: "";
      width: 100%;
      height: 100%;
      position: absolute;
      background-color: #f2f2f2;
      top: 0;
      right: 0;
      border-collapse: collapse;
    }
  }
  .VueTables__table .actions-column > * {
    position: relative;
    z-index: 1;
  }
  .table-striped tbody tr:nth-of-type(odd) > .actions-column {
    &:after {
      background-color: #e6e6e6;
    }
  }
  .VueTables__table .id-column {
    max-width: 100px;
  }
  [class$="filter-wrapper"] {
    min-width: 80px;
    max-width: fit-content;
  }
 .VueTables__limit {
     float: right !important;
  }
.btn-filter {
    background: #fff !important;
    color:#000000 !important;
    border: 1px solid $black;
}
</style>
<style>

.return {
  color: black;
  cursor: pointer;
}
.return:hover {
  text-decoration: underline !important;
}
.filters-selected {
  border: 1px solid #b3b3b3;
  padding: 1rem;
}
.black {
  color: #000 !important;
}
.bolded {
  font-weight: bold !important;
}
.selection .modal-container {
  max-width: 60vw !important;
}
.selection .modal-container .body-header {
  display: flex;
}
.selection .modal-container .body-modal .form-inputs-line {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100px;
}
.selection .modal-container .body-modal .inputs-clone {
  display: flex;
  width: 100%;
  position: relative;
}
.selection .modal-container .body-modal .form-input-1 {
  width: 50%;
  margin-right: 2rem;
}
.selection .modal-container .body-modal .inputs-clone i {
  position: absolute;
  right: 25%;
  cursor: pointer;
}
.selection .modal-container .body-modal .form-input-2 {
  display: flex;
  flex-direction: column;
}

.selection .modal-container .body-modal .form-input-2 input {
  width: 40% !important;
}
.selection .modal-container .body-modal .add-btn {
  display: flex;
  align-items: center;
  cursor: pointer;
  width: 34%;
}
.selection .modal-container .body-modal .add {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  font-weight: bold;
  font-size: 1.5rem;
  color: #fff;
  background: #333333;
  margin-right: 1.3rem;
}
.selection .modal-container .controls {
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
}
.selection .modal-container .controls .btn-save {
  background: #000;
  color: #fff;
  border-radius: 0px;
  border: none;
  padding: 0.5rem 3rem;
  border: 1px solid #000;
  cursor: pointer;
}
.selection .modal-container .controls .cancel-btn {
  background: #fff;
  color: #000;
  border-radius: 0px;
  border: 1px solid #000;
  padding: 0.5rem 3rem;
  margin-right: 1rem;
  cursor: pointer;
}

.pointer {
  cursor: pointer;
}
.warning-text {
  color: #bb0a30;
}
.disable-upload {
  pointer-events: none !important;

  opacity: 0.3 !important;
}
.btn-disable {
  background: rgba(0, 0, 0, 0.5) !important;
}
.has-error {
  border: 1px solid red;
}
.alert-text {
  color: #bb0a30;
  margin-top: 0.5rem;
}
.modal-alert .modal-container {
  max-width: 20vw !important;
}
.scrollable {
  overflow-y: scroll;
  height: 180px;
}
@media (min-width: 768px) and (max-width: 1440px) {
  .modal-alert .modal-container {
    max-width: 40vw !important;
  }
  .selection .modal-container {
    max-height: 70vh !important;
  }
}
</style>
